import { render, staticRenderFns } from "./AtendimentosDoDiaTable.vue?vue&type=template&id=847644fe"
import script from "./AtendimentosDoDiaTable.vue?vue&type=script&lang=ts"
export * from "./AtendimentosDoDiaTable.vue?vue&type=script&lang=ts"
import style0 from "./AtendimentosDoDiaTable.vue?vue&type=style&index=0&id=847644fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports